module.exports = __webpack_public_path__ + "img/5.2110e566.png";